// src/hooks/useForegroundPush.ts
import { useEffect } from 'react';
import { getMessaging } from 'services/firebase'; // wrapper async
import { toast } from 'react-toastify';

/**
 * Listen for FCM messages while the page is in foreground and
 * show a toast. Works only on browsers that support Firebase Messaging.
 */
export function useForegroundPush() {
  useEffect(() => {
    // flag globale (resta true anche dopo hot-reload)
    if ((window as any).__pushFgListenerAdded) return;

    (async () => {
      const messaging = await getMessaging();
      if (!messaging) return; // Safari/WebKit → esci silenzioso

      const unsub = messaging.onMessage(
        (payload: {
          notification?: { title?: string; body?: string };
          data?: { title?: string; body?: string };
        }) => {
          const { notification, data } = payload;
          // Mostra il toast solo se la tab è visibile
          if (document.visibilityState !== 'visible') return;

          const title = data?.title || notification?.title || 'Nuova notifica';
          const body = data?.body || notification?.body || '';
          console.log('[push-fg]', title, body);
          toast.info(`${title}\n${body}`);
        },
      );

      (window as any).__pushFgListenerAdded = true;

      // cleanup in uscita (solo build di produzione)
      return () => unsub();
    })();
  }, []);
}
